// extracted by mini-css-extract-plugin
var _1 = "StarBar__main--W0Uv2";
var _2 = "StarBar__separate--h6FUA";
var _3 = "StarBar__separateOuter--H0lKV";
var _4 = "StarBar__vert--Yo8nP";
export { _1 as "main", _2 as "separate", _3 as "separateOuter", _4 as "vert" }
